import Vue from 'vue'
import store from "@/store";

const state = {
  token: null, //ikkim
  notiReject: false,
  showGraph: false, //210928
  platformTitle: null,
  isCMonitorSchool:false, //220211
  isAirSchool:false,
  isShowSearch:false,
  showDetail: 2,
    //0: 숨기기
    //1: 간단보기
    //2: 상세보기 (default)
  showIndicator:false, //221121 -- 전체현황, 실내외 공기질 통합표시 (default:통합공기질 표시안함.)
  showIndividualControl: 1, //221212 -- 전체현황, 개별제어판 표시여부 (default:동작현황으로 표시)
  showInOutDisplayMode: -1, //230608 -- 전체현황에서 실내/실외 표시방식
    //-1: init
    //0: 실내만 표시
    //1: 실내/실외 각각 표시
    //2: 실내+실외/실외 별도 표시 안함
    //3: 실내+실외/실외 별도 표시
  leftOverDeviceType: 0, //leftover device type -- 3: 잔반측정기2
  leftGradeWidth: '300px',
  leftGradeWidthMobile: '0px',
  mapLevel:5,
  mapLevelMobile:5,
  lastDashboard: 'main', //마지막 전체현황 타입을 저장한다(main or map)
  headerHeight: 0,
  leastHeaderHeight: 0,
  simpleMode:2,
    //0: 매우 작게
    //1: 작게
    //2: 보통 ** default
    //3: 크게
    //4: 매우 크게

  selectedGrade:0  
}

function getOthers(state, key) {
  let v = localStorage.getItem(key);
  if(v) {
    state[key] = v;
  }

  if(state[key] == 'true') {
    //console.log(`GET ${key} true`);
    state[key] = true;
  }  
  if(state[key] == 'false') {
    //console.log(`GET ${key} false`);
    state[key] = false;
  }  

  //console.log(`GET ${key} = ${state[key]}`);
  return state[key];
}

function setOthers(state, key, value) {
    
  //console.log(`SET ${key} = ${value}`);

  localStorage.setItem(key, value);

  state[key] = value;
}

const getters = {
  token:                (state) => {return getOthers(state, 'token');}, //ikkim
  notiReject:           (state) => {return getOthers(state, 'notiReject');}, //ikkim
  showGraph:            (state) => {return false; /*return getOthers(state, 'showGraph');*/}, //ikkim
  getPlatformTitle:     (state) => {return getOthers(state, 'platformTitle');},
  isCMonitorSchool:     (state) => {return getOthers(state, 'isCMonitorSchool');}, //220211
  isAirSchool:          (state) => {return getOthers(state, 'isAirSchool');}, //220211
  isShowSearch:         (state) => {return getOthers(state, 'isShowSearch');}, //220211
  showDetail:           (state) => {return getOthers(state, 'showDetail');}, //221121
  showIndicator:        (state) => {return getOthers(state, 'showIndicator');}, //221121
  showIndividualControl:(state) => {return 1; /*return getOthers(state, 'showIndividualControl');*/}, //항상 동작현황으로 표시하는것으로 수정 //230311
  showInOutDisplayMode: (state) => {
    //console.log("showInOutDisplayMode==="+state.showInOutDisplayMode);
    
    state.showInOutDisplayMode = getOthers(state, 'showInOutDisplayMode');

    if(state.showInOutDisplayMode == -1) {
      state.showInOutDisplayMode = 0;

      /*
      let isShelter = Vue.prototype.$common.isShelter();
      //console.log("isShelter==="+isShelter);
      if(isShelter) {
        //shelter인 경우, default: 실내+실외, 실외 표시 안함
        //state.showInOutDisplayMode = 0;
        //241217 실내만 표시로 변경
        state.showInOutDisplayMode = 3;
      } else {
        //shelter인 경우, default: 실내, 실외 각각 표시 (기존과 동일)
        state.showInOutDisplayMode = 2;
      }
      */ 
    }
    return state.showInOutDisplayMode;
  },
  leftOverDeviceType:   (state) => {return getOthers(state, 'leftOverDeviceType');},
  leftGradeWidth:       (state) => {return getOthers(state, 'leftGradeWidth');},
  leftGradeWidthMobile: (state) => {return getOthers(state, 'leftGradeWidthMobile');},
  mapLevel:             (state) => {return getOthers(state, 'mapLevel');},
  mapLevelMobile:       (state) => {return getOthers(state, 'mapLevelMobile');},
  lastDashboard :       (state) => {return getOthers(state, 'lastDashboard');},
  headerHeight :        (state) => {return getOthers(state, 'headerHeight');},
  leastHeaderHeight :   (state) => {return getOthers(state, 'leastHeaderHeight');},
  simpleMode :          (state) => {return getOthers(state, 'simpleMode');},
  selectedGrade :       (state) => {return getOthers(state, 'selectedGrade');},
}

const mutations = {
  setToken(state, tok) {
    setOthers(state, 'token', tok);

    //state.token = tok;
    //console.log("setToken:"+tok);
  },
  setNotiReject(state, reject) {
    setOthers(state, 'notiReject', reject);

    //state.notiReject = reject;
    //console.log("setNotiReject:"+reject);
  },
  setShowGraph(state, show) {
    setOthers(state, 'showGraph', show);

    //state.showGraph = show;
    //console.log("setShowGraph:"+show);
  },
  //220124
  setPlatformTitle(state, title) {
    setOthers(state, 'platformTitle', title);

    //state.platformTitle = title;
    //console.log("setNotiReject:"+reject);
  },
  //220211
  setIsCMonitorSchool(state, isCmonitor) {
    setOthers(state, 'isCMonitorSchool', isCmonitor);

    //state.isCMonitorSchool = isCmonitor;
    //console.log("setIsCMonitorSchool:"+isCmonitor);
  },
  setLeftOverDeviceType(state, type) {
    setOthers(state, 'leftOverDeviceType', type);

    //state.leftOverDeviceType = type;
  },
  setLeftGradeWidth(state, width) {
    setOthers(state, 'leftGradeWidth', width);

    //state.leftGradeWidth = width;
  },
  setHeaderHeight(state, height) {
    setOthers(state, 'headerHeight', height);

    //state.leftGradeWidth = width;
  },
  setLeastHeaderHeight(state, height) {
    setOthers(state, 'leastHeaderHeight', height);

    //state.leftGradeWidth = width;
  },
  setLeftGradeWidthMobile(state, width) {
    setOthers(state, 'leftGradeWidthMobile', width);

    //state.leftGradeWidthMobile = width;
  },
  setMapLevel(state, width) {
    setOthers(state, 'mapLevel', width);

    //state.mapLevel = width;
  },
  setMapLevelMobile(state, width) {
    setOthers(state, 'mapLevelMobile', width);

    //state.mapLevelMobile = width;
  },
  setLastDashboard(state, dashboard) {
    setOthers(state, 'lastDashboard', dashboard);

    //state.lastDashboard = dashboard;
  },
  setIsAirSchool(state, isAir) {
    setOthers(state, 'isAirSchool', isAir);
    
    //state.isAirSchool = isAir;
  },
  setIsShowSearch(state, show) {
    setOthers(state, 'isShowSearch', show);

    //state.isShowSearch = show;
  },
  setShowDetail(state, show) {
    setOthers(state, 'showDetail', show);
    
    //state.showDetail = show;
  },
  setShowIndicator(state, show) {
    setOthers(state, 'showIndicator', show);

    //state.showIndicator = show;
  },
  setShowIndividualControl(state, show) {
    setOthers(state, 'showIndividualControl', show);

    //state.showIndividualControl = show;
  },
  setShowInOutDisplayMode(state, mode) {
    setOthers(state, 'showInOutDisplayMode', mode);

    //console.log("setShowInOutDisplayMode = "+mode);
    //state.showInOutDisplayMode = mode;
  },
  setSimpleMode(state, mode) {
    setOthers(state, 'simpleMode', mode);

    //console.log("setShowInOutDisplayMode = "+mode);
    //state.showInOutDisplayMode = mode;
  },
  setSelectedGrade(state, grade) {
    setOthers(state, 'selectedGrade', grade);

    //console.log("setSelectedGrade = "+grade);
    //state.showInOutDisplayMode = mode;
  },
}

const actions = {
  setToken({commit}, token) {
    commit('setToken', token);
  },
  setNotiReject({commit}, reject) {
    commit('setNotiReject', reject);
  },
  setShowGraph({commit}, show) {
    commit('setShowGraph', show);
  },
  setPlatformTitle({commit}, title) {
    commit('setPlatformTitle', title);
  },
  setIsCMonitorSchool({commit}, use) {
    commit('setIsCMonitorSchool', use);
  },
  setLeftOverDeviceType({commit}, use) {
    commit('setLeftOverDeviceType', use);
  },
  setLeftGradeWidth({commit}, use) {
    commit('setLeftGradeWidth', use);
  },
  setHeaderHeight({commit}, use) {
    commit('setHeaderHeight', use);
  },
  setLeastHeaderHeight({commit}, use) {
    commit('setLeastHeaderHeight', use);
  },
    setLeftGradeWidthMobile({commit}, use) {
    commit('setLeftGradeWidthMobile', use);
  },
  setMapLevel({commit}, use) {
    commit('setMapLevel', use);
  },
  setMapLevelMobile({commit}, use) {
    commit('setMapLevelMobile', use);
  },
  setLastDashboard({commit}, use) {
    commit('setLastDashboard', use);
  },
  setIsShowSearch({commit}, show) {
    commit('setIsShowSearch', show);
  },
  setShowDetail({commit}, show) {
    commit('setShowDetail', show);
  },
  setShowIndicator({commit}, show) {
    commit('setShowIndicator', show);
  },
  setShowIndividualControl({commit}, show) {
    commit('setShowIndividualControl', show);
  },
  showInOutDisplayMode({commit}, show) {
    commit('showInOutDisplayMode', show);
  },
  setSimpleMode({commit}, mode) {
    commit('setSimpleMode', mode);
  },
  setSelectedGrade({commit}, grade) {
    commit('setSelectedGrade', grade);
  },
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};